var map = {
	"./Ad-Banner-slide-1.jpg": "10e6",
	"./Ad-Banner-slide-2.jpg": "7918",
	"./Ad-Banner-slide-3.jpg": "a90c",
	"./Ad-Banner-slide-4.jpg": "3ff6",
	"./Ad-Banner-slide-5.jpg": "69be"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8f6b";